import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/comparison/[name]/PageContent.tsx");
